module.exports = {
    'ec2-18-138-132-10.ap-southeast-1.compute.amazonaws.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
    // "ec2-18-138-132-10.trioclear.com": {
    //   logo_path: "/img/logo_color.png",
    //   white_logo_path: "/img/logo_white.png",
    //   main_background_color: "linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)",
    //   main_color_1: "#485291",
    //   main_color_2: "#543f8a",
    //   main_color_3: "#1a1a1a",
    //   main_color_4: "#4d4d4d",
    //   contact_phone: "+852 22505101",
    //   contact_email: "cs@trioclear.com.hk",
    //   social_media:{
    //     facebook: "https://www.facebook.com/TrioClear.Official",
    //     instagram: "https://www.instagram.com/trioclear.official",
    //     wechat: "/img/wechat_qr_code.png",
    //     weibo: "https://weibo.com/u/7669742081"
    //   }
    // },
    'ec2-18-138-132-10.ap-southeast-1.compute.amazonaws.com:4000': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
    'ec2-13-214-245-116.ap-southeast-1.compute.amazonaws.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
    localhost: {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
    'ecom.trioclear.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '',
            weibo: '',
        },
    },
    'pro.trioclear.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '',
            weibo: '',
        },
    },
    'nz.trioclear.com': {
        logo_path: '/img/logo_color.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '',
            weibo: '',
        },
    },
    'aus.trioclear.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '',
            weibo: '',
        },
    },
    'pro.trioclear.com.cn': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '4000-529-066',
        contact_email: 'info@trioclear.com.cn',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
    'prodev.trioclear.com': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '+852 22505101',
        contact_email: 'cs@trioclear.com.hk',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '',
            weibo: '',
        },
    },
    'prodev.trioclear.com.cn': {
        logo_path: '/img/logo_color.png',
        white_logo_path: '/img/logo_white.png',
        main_background_color: 'linear-gradient(42deg, rgba(46,126,162,1) 0%, rgba(89,54,135,1) 100%)',
        main_color_1: '#485291',
        main_color_2: '#543f8a',
        main_color_3: '#1a1a1a',
        main_color_4: '#4d4d4d',
        contact_phone: '4000-529-066',
        contact_email: 'info@trioclear.com.cn',
        social_media: {
            facebook: 'https://www.facebook.com/TrioClear.Official',
            instagram: 'https://www.instagram.com/trioclear.official',
            wechat: '/img/wechat_qr_code.png',
            weibo: 'https://weibo.com/u/7669742081',
        },
    },
};
